export default "__VITE_ASSET__CGkeDsrh__"